export default __webpack_public_path__ + "static/media/hacker2.b5125be6.png";